import React from 'react';

/**
 * WidgetErrorBoundary — swallows render errors from layout engagement widgets
 * (FloatingCTA, SmartCTAEngine, SMSWidget, PersonalizedBlogRecommendations, etc.)
 * so a throw in any one widget never blanks the entire page.
 *
 * The app has no top-level error boundary, so without this guard a single
 * render-time throw in a layout widget unmounts the React root and produces
 * a blank page. This boundary renders null on error — the page content above
 * it (rendered before the widgets) stays visible.
 */
export default class WidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('[WidgetErrorBoundary]', this.props.name || 'widget', error, errorInfo);
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}